import React, { PropTypes } from 'react';

import styled from 'styled-components';

import { NitroIcon } from 'nitro-components';

const Icon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 30px;
`;

const ContentIcon = Icon.extend`
  left: 0;
`;

const NotificationCloseIcon = Icon.extend`
  right: 0;
`;

const NotificationIcon = ({ icon = 'success-circle', variant = 'primary', size }) => (
  <div onClick ={()=>{console.log("some");}}>
    <ContentIcon>
      <NitroIcon name={icon} variant={variant} size={size} />
    </ContentIcon>
    <NotificationCloseIcon>
      <NitroIcon name="close" variant="base3" size={14} />
    </NotificationCloseIcon>
  </div>
);

NotificationIcon.propTypes = {
  icon: PropTypes.string,
  variant: PropTypes.string,
  size:PropTypes.number
};

NotificationIcon.defaultProps = {
  size: 32
};

export default NotificationIcon;



// WEBPACK FOOTER //
// ./src/components/libs/notification/NotificationIcon.js